import React from 'react';
import { connect } from 'react-redux';
import { Button, Input } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import parseHtmlToReact from 'html-react-parser';
import PropTypes from 'prop-types';

import { FiveStarRate, /* Grid, Col,  Section, */ InlineSet } from 'bricks';
import { isScreenBelow800 } from 'store/common/settings/breakpoint/selectors';
import { FEETBACK_FORM } from 'store/ProductDetails/common/constants';
import {
  changeFeedbackInput,
  setFeedbackRating,
  submitFeedback,
} from 'store/ProductDetails/feedbackLocal/actions';
import {
  getFeedbackAgreement,
  getFeedbackCommentMaxLength,
  getFeedbackErrorDetails,
  getFeedbackFormData,
} from 'store/ProductDetails/selectors';
/* import { SmartTextarea } from 'components'; */

import commonStyles from 'styles/common.pcss';

import styles from './styles.pcss';

const cx = classNames.bind({ ...styles, ...commonStyles });

/**
 * A simple anonymous form for submitting feedback
 * TODO: Refactor on redux-form
 */
class FeedbackForm extends React.Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.onSubmit();
  };

  render() {
    const {
      agreement,
      errors,
      formData,
      isMobile,
      onChangeInput,
      onChangeRating,
      /* commentMaxLength, */
    } = this.props;

    return (
      <div id={FEETBACK_FORM}>
        <div>
          <div className={cx('title')}>Оставьте свой отзыв</div>
          <div className={cx('component')}>
            <div className={cx('rating', 'padb-s')}>
              <InlineSet>
                <span className={cx('labelReview', isMobile && 'mobile')}>Ваша оценка</span>
                <FiveStarRate onChange={onChangeRating} value={formData.Rating} />
                {errors.Rating ?
                  <span className={cx('ratingError')}>{errors.Rating}</span>
                : null}
              </InlineSet>
            </div>
            <form onSubmit={this.handleSubmit}>
              <div className={cx('contactRow', isMobile && 'mobile')}>
                <div className={cx('contactField', isMobile && 'mobile')}>
                  <div className={cx('label', isMobile && 'mobile')}>Ваше имя</div>
                  <Input
                    errorMessage={errors.Name}
                    onChange={(e) => onChangeInput({ name: e.target.value })}
                    placeholder=""
                    value={formData.Name}
                  />
                  {/* <SmartInput
                          value={formData.Name}
                          onChange={name => onChangeInput({ name })}
                          status={errors.Name ? 'fail' : null}
                          msg={errors.Name}
                          placeholder={isMobile ? 'Ваше имя' : null}
                        />
                  */}
                </div>
                <div className={cx('contactField', isMobile && 'mobile')}>
                  <div className={cx('label', isMobile && 'mobile')}>Электронная почта</div>
                  <Input
                    errorMessage={errors.Email}
                    onChange={(e) => onChangeInput({ email: e.target.value })}
                    placeholder=""
                    value={formData.Email}
                  />
                  {/*
                    <SmartInput
                      value={formData.Email}
                      onChange={email => onChangeInput({ email })}
                      status={errors.Email ? 'fail' : null}
                      msg={errors.Email}
                      placeholder={isMobile ? 'Электронная почта' : null}
                    />
                */}
                </div>
              </div>
              <div className={cx('reviewField', isMobile && 'mobile')}>
                <div className={cx('label', isMobile && 'mobile')}>Ваш комментарий</div>
                <Input
                  errorMessage={errors.Comment}
                  isTextArea
                  isTextAreaResizable
                  onChange={(e) => onChangeInput({ comment: e.target.value })}
                  placeholder=""
                  value={formData.Comment}
                />
                {/*
                  <SmartTextarea
                    value={formData.Comment}
                    onChange={comment => onChangeInput({ comment })}
                    status={errors.Comment ? 'fail' : null}
                    msg={errors.Comment}
                    placeholder={isMobile ? 'Оставьте свой комментарий' : null}
                    maxLength={`${commentMaxLength}`}
                  />
                  */}
              </div>
              <div className={cx('push')}>
                <Button className={cx('button')} fullWidth={isMobile} onClick={this.handleSubmit}>
                  Отправить отзыв
                </Button>
              </div>
              {agreement && <div className={cx('message')}>{parseHtmlToReact(agreement)}</div>}
            </form>
          </div>
        </div>
      </div>
    );
  }
}

FeedbackForm.propTypes = {
  agreement: PropTypes.string,
  errors: PropTypes.shape({
    Comment: PropTypes.string,
    Email: PropTypes.string,
    Name: PropTypes.string,
    Rating: PropTypes.string,
  }),
  formData: PropTypes.shape({
    Comment: PropTypes.string,
    Email: PropTypes.string,
    Name: PropTypes.string,
    Rating: PropTypes.number,
  }),
  isMobile: PropTypes.bool,
  onChangeInput: PropTypes.func,
  onChangeRating: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  /* commentMaxLength: PropTypes.number, */
};

const mapStateToProps = (state) => ({
  agreement: getFeedbackAgreement(state),
  commentMaxLength: getFeedbackCommentMaxLength(state),
  errors: getFeedbackErrorDetails(state),
  formData: getFeedbackFormData(state),
  isMobile: isScreenBelow800(state),
});

const mapDispatchToProps = {
  onChangeInput: changeFeedbackInput,
  onChangeRating: (value) => setFeedbackRating({ value }),
  onSubmit: submitFeedback,
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackForm);
